<template>
    <div class="slide" :data-layout="slide.layout"
         :style="{'--color':style.color, '--background':style.background, '--fontFamily':style.fontFamily}">
        <editable-text-block class="title" :value="slide.title" @change="change( 'title', $event)"/>
        <editable-text-block class="subtitle" :value="slide.subtitle"
                             @change="change( 'subtitle', $event)"/>
        <div class="textContainer">
            <editable-text-block v-for="(text,j) in slide.texts" :key="`${j}`" class="text" :value="text"
                                 @change="change( 'text', $event, j)">{{ text.content }}
            </editable-text-block>
        </div>
    </div>
</template>
<script>
import EditableTextBlock from "@/components/EditableTextBlock.vue";

export default {
    name: 'SingleSlidePreview',
    components: {EditableTextBlock},
    props: {
        xml: {
            type: Node,
            required: true
        },
        style: {
            type: Object,
            default: () => ({})
        },
        editable: {
            type: Boolean,
            default: false
        },
        slidesChangeSymbol: {
            type: Symbol,
            default: Symbol()
        }
    },
    data() {
        return {}
    },
    methods: {
        change(field, value, index = 0) {
            console.log('xmlChange')
            const element = this.xml.querySelectorAll(field)[index];
            if (element) {
                element.textContent = value;
            }
        }
    },
    computed: {
        slide() {
            void this.slidesChangeSymbol
            const texts = [...this.xml.querySelectorAll('text')].map(text => {
                return text.textContent;
            });
            return {
                texts,
                title: this.xml.querySelector('title')?.textContent,
                subtitle: this.xml.querySelector('subtitle')?.textContent,
                layout: this.xml.attributes.layout?.value??'default'
            };
        }
    }
}
</script>
<style>
.slide {
    --unit: 1px;
    width: calc(960 * var(--unit));
    height: calc(540 * var(--unit));
    border: 1px solid black;
    margin: 8px auto;
    background: var(--background);
    color: var(--color);
    font-family: var(--fontFamily);
    @media(max-width: 1020px) {
        --unit:1vw/10.2;
    }

    &[data-layout="titleOnly"] {
        display: grid;
        grid-template-rows: 1fr;
        text-align: center;

        .title {
            font-size: calc(48 * var(--unit));
            align-self: center;
        }

        .subtitle {
            display: none;
        }

        .textContainer {
            display: none;
        }
    }
    &[data-layout="titleAndSubtitle"] {
        display: grid;
        grid-template-rows: 1fr 1fr;
        text-align: center;

        .title {
            font-size: calc(48 * var(--unit));
            align-self: self-end;

        }

        .subtitle {
            font-size: calc(24 * var(--unit));
        }
        .textContainer {
            display: none;
        }
    }

    &[data-layout="default"] {
        display: grid;
        grid-template-rows: calc(80 * var(--unit)) calc(48 * var(--unit)) 1fr;
        text-align: left;

        .title {
            font-size: calc(48 * var(--unit));
            padding: calc(32 * var(--unit)) calc(32 * var(--unit)) 0 calc(32 * var(--unit));
            line-height: 1;
        }

        .subtitle {
            font-size: calc(24 * var(--unit));
            padding: 0 calc(32 * var(--unit));
            line-height: 1;
        }

        .textContainer {
            display: block;
            grid-row: 3;
        }

        .text {
            font-size: calc(18 * var(--unit));
            flex: 1 1 1px;
            padding: 0 calc(32 * var(--unit));
        }
    }

    &[data-layout="defaultSide"] {
        display: grid;
        grid-template-rows: calc(80 * var(--unit)) calc(48 * var(--unit)) 1fr;
        text-align: left;

        .title {
            font-size: calc(48 * var(--unit));
            padding: calc(32 * var(--unit)) calc(32 * var(--unit)) 0 calc(32 * var(--unit));
            line-height: 1;
        }

        .subtitle {
            font-size: calc(24 * var(--unit));
            padding: 0 calc(32 * var(--unit));
            line-height: 1;
        }

        .textContainer {
            display: flex;
            grid-row: 3;
        }

        .text {
            font-size: calc(18 * var(--unit));
            flex: 1 1 1px;
            padding: 0 calc(16 * var(--unit));
        }
    }
}
</style>
